import { createElement, useEffect, useState } from 'react';
import { Form, Select, Grid, DatePicker2, Input, } from '@alifd/next';
import { fIsMobile } from '../../../utils';
import { previewDataByField } from '../../../api/common';
import DrawPicker from '../../common/drawPicker';
import MobleDateRangePicker from '../../common/MobleDateRangePicker';
import MobleTimeDateRangePicker from '../../common/MobleTimeDateRangePicker';
import RangeQuery from '../../common/rangeQuery';
import dayjs from 'dayjs';
const Option = Select.Option;
const { RangePicker } = DatePicker2;
const FormItem = Form.Item;
const { Row, Col } = Grid;
const RangePreset = {
    上月: [
        dayjs().subtract(1, 'month').startOf('month'),
        dayjs().subtract(1, 'month').endOf('month'),
    ],
    本月: [dayjs().startOf('month'), dayjs().endOf('month')],
    下月: [dayjs().add(1, 'month').startOf('month'), dayjs().add(1, 'month').endOf('month')],
};
const TableHeader = (props) => {
    const { field, dataset, setErrmsg, setError, filterSearch, filterReset, } = props;
    const [isMoble, setIsMoble] = useState(fIsMobile());
    const listenResize = () => {
        setIsMoble(fIsMobile());
    };
    useEffect(() => {
        window.addEventListener('resize', listenResize);
        return () => {
            window.removeEventListener('resize', listenResize);
        };
    }, []);
    const [maps, setMap] = useState({});
    useEffect(() => {
        try {
            if (field && field?.length && dataset) {
                const promises = field.map((item) => {
                    const whiteList = ['singleSelect', 'multipleSelect', 'drawerSelect'];
                    if (whiteList.includes(item?.additional?.searchType || 'fuzzyQuery')) {
                        return new Promise((resolve, reject) => {
                            const params = {
                                groupId: dataset?.id,
                                type: 'Target',
                                fieldList: [
                                    {
                                        alias: item?.originName,
                                        filedId: item?.id,
                                    },
                                ],
                                groupAxis: [
                                    {
                                        alias: item?.originName,
                                        fieldCode: item?.fieldShortName,
                                        dataType: item?.type,
                                        filedId: item?.id,
                                    },
                                ],
                            };
                            previewDataByField(params).then((res) => {
                                if (res.code === 200) {
                                    console.log("111222333", res);
                                    resolve(res);
                                }
                                else {
                                    reject(res);
                                }
                            });
                        });
                    }
                    else {
                        return new Promise((resolve) => {
                            resolve({
                                data: {
                                    fields: [item],
                                    data: [],
                                },
                            });
                        });
                    }
                });
                Promise.all(promises).then((res) => {
                    const temp = {};
                    res.forEach((re, index) => {
                        const prop = re?.data?.fields[0].fieldShortName;
                        temp[re.data.fields[0].name] = [
                            [
                                ...re.data.data.map((e) => ({
                                    label: e[prop],
                                    value: e[prop],
                                    key: e[prop],
                                    checked: true,
                                })),
                            ],
                            field[index]?.additional?.searchType || 'fuzzyQuery',
                        ];
                        if (field[index]?.additional?.searchType !== 'drawerSelect') {
                            temp[re.data.fields[0].name][0].push({ label: '全部', value: 'allData' });
                        }
                    });
                    setMap(temp);
                });
            }
            else {
                setMap({});
            }
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('查询功能初始化异常,请检查配置项或更新组件');
        }
    }, [field, dataset]);
    const formItemLayout = {
        labelCol: { fixedSpan: 5 },
    };
    return (createElement("div", null,
        createElement("div", { className: "table-filter" },
            createElement(Form, null,
                createElement(Row, { wrap: true, gutter: 60 },
                    Object.keys(maps).map((name) => (createElement(Col, { span: isMoble ? 12 : 8 },
                        maps[name][1] === 'singleSelect' ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(Select, { hasClear: true, showSearch: true, style: { width: '100%', height: '32px' }, placeholder: name }, (maps[name][0] || []).map((e) => (createElement(Option, { value: e?.value }, e?.label)))))) : null,
                        maps[name][1] === 'multipleSelect' ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(Select, { hasClear: true, showSearch: true, mode: "multiple", style: { width: '100%' }, placeholder: name }, (maps[name][0] || []).map((e) => (createElement(Option, { value: e?.value }, e?.label)))))) : null,
                        maps[name][1] === 'dateRange' && isMoble ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(MobleDateRangePicker, { name: name }))) : null,
                        maps[name][1] === 'dateRange' && !isMoble ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(RangePicker, { format: "YYYY-MM-DD", outputFormat: "YYYY-MM-DD", style: { width: '100%' }, placeholder: name, hasClear: true, preset: RangePreset }))) : null,
                        maps[name][1] === 'dateTimeRange' && isMoble ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(MobleTimeDateRangePicker, { name: name }))) : null,
                        maps[name][1] === 'dateTimeRange' && !isMoble ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(RangePicker, { showTime: true, format: "YYYY-MM-DD HH:mm:ss", outputFormat: "YYYY-MM-DD HH:mm:ss", style: { width: '100%' }, placeholder: name, hasClear: true, preset: RangePreset }))) : null,
                        maps[name][1] === 'drawerSelect' ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(DrawPicker, { title: name, options: maps[name][0] }))) : null,
                        maps[name][1] === 'rangeQuery' ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(RangeQuery, null))) : null,
                        maps[name][1] === 'fuzzyQuery' ? (createElement(FormItem, Object.assign({}, formItemLayout, { name: name, label: isMoble ? undefined : name }),
                            createElement(Input, { placeholder: "\u8BF7\u8F93\u5165\u6A21\u7CCA\u67E5\u8BE2\u5B57\u6BB5" }))) : null))),
                    Object.keys(maps).length ? (createElement(Col, { span: isMoble ? 12 : 8 },
                        createElement("div", { style: { textAlign: 'left' } },
                            createElement(Form.Reset, { className: "reset_btn", type: "normal", onClick: filterReset }, "\u91CD\u7F6E"),
                            createElement(Form.Submit, { className: "submit_btn", type: "normal", validate: true, onClick: filterSearch }, "\u67E5\u8BE2")))) : null)))));
};
export default TableHeader;
